import { Overlay as BootstrapOverlay } from 'react-bootstrap';
import { type OverlayProps } from 'react-bootstrap';

const Overlay = ({
  containerPadding = 20,
  placement = 'bottom',
  popperConfig = {
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10],
        },
      },
    ],
  },
  ...props
}: OverlayProps) => (
  <BootstrapOverlay
    {...props}
    containerPadding={containerPadding}
    placement={placement}
    popperConfig={popperConfig}
  />
);

export default Overlay;
